import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../geometry.js";
import { b as t } from "../../chunks/vec2.js";
import { projectPointOnLine as e } from "./coordsUtils.js";
import n from "../Point.js";

function o(o, m) {
  var r = m.spatialReference,
      i = [m.x, m.y];
  var s = Number.POSITIVE_INFINITY,
      x = 0,
      c = 0;
  var a = [0, 0],
      f = "extent" === o.type ? [[[o.xmin, o.ymin], [o.xmin, o.ymax], [o.xmax, o.ymax], [o.xmax, o.ymin], [o.xmin, o.ymin]]] : o.rings;

  var _iterator = _createForOfIteratorHelper(f),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _n = _step.value;

      for (var _o = 0; _o < _n.length - 1; _o++) {
        e(a, i, _n, _o);

        var _m = t(i, a);

        _m < s && (s = _m, x = a[0], c = a[1]);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return {
    coordinate: new n({
      x: x,
      y: c,
      spatialReference: r
    }),
    distance: s
  };
}

export { o as nearestCoordinate };